import React from 'react';
import { Sheet as KiteSheet } from '@kite-js/experimental';
import { SheetPropsWithActions } from '@kite-js/experimental/lib/Sheet/types';
import { WhiteLabelThemeProvider } from 'app/WhiteLabelThemeProvider';
import { useSelector } from 'react-redux';
import { selectWhitelabelConfigFromBootstrap } from 'store/slice/bootstrap';

type Props = SheetPropsWithActions;

const Sheet: React.FC<Props> = ({ children, ...props }) => {
    const whitelabelConfig = useSelector(selectWhitelabelConfigFromBootstrap);

    return (
        <KiteSheet {...props}>
            <WhiteLabelThemeProvider whiteLabelId={whitelabelConfig.whiteLabelId}>{children}</WhiteLabelThemeProvider>
        </KiteSheet>
    );
};

Sheet.displayName = 'Sheet';
export default Sheet;
